const FEATURE_NAME = 'gallery';
const namespace = 'ui-pdp-gallery';

export { namespace, FEATURE_NAME };
